import api from './axios';

export const getCurrentWeather = (parcelId) => api.get(`/weather/current/${parcelId}/`);
export const getForecast = (parcelId) => api.get(`/weather/forecast/${parcelId}/`);
